var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1297_870",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1297_870",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADnklEQVR4nO2cSWsVQRSFK0bjCI4/QJeOf0DdKroyIuJWBReK5BfIQ9waSUjsPqdafJBlL10EozhsdOGEO4kDETfOUZyiG1sKOyDyuhPNS9etfveD2gVyOLm5dev2rTJGURRFURRFURSlUxkcHFxM8iyA9wC+kGR/f/9S37pqZzKAUZLZX4u+tXWCyRmAT7711d5k/l4ffWvsBJMzAOd86+wEk0fdz/nWGixpmvaQvDSDyZebzeYS31qDRU2uADW5AtTkClCTK0BNrgDXp5iphPO1APwgOUnyKcnr+M1JkluzLOsyIUEy8W0o/++P8IbkBWvtTvGmNxqNBSS/+TaNc1+P4zg+6lKgkWo0gCkBRmVtWi9IHjISAWAFGJS1cwG4aq3dYCThjtBSN0POzewPAPYbSUhtHpFcFEXR6iRJNpLcR/JUXn38S7o7YyQh1exWkFzpNj8Ad2YZ3TZN024jhZDMnobkLpL3Z2O2kUSIZqdp2p0fZL5qGqmAKIq2kHxUEiA/rbW9RhIhRrYjSZI1AG6VVSNxHK83kgjVbJLLyswmecVIY5ZmDxhhuMguSyPW2oMmQLM/S2zs5Dm75QYJ4Lmr001gAzRTrm9iBJJXI0UBcsRIpMTsi0YorvQj+aAgQMYl/if+afaASxf5Ufji8PDwCiMYa+3ukqjeYSSTZVmX2GhoAcm7BUbrgGY7AXCswOjXIQWMeJrN5iqS3wtKvc2+9dUKkjcKNsUTvrXVCgCNgvQR+dZWK6y1vQURfc23tloRx/Gmgoh+5ltbrSC5rsDot7611fFGWdZiffetrVYMqtHVoKmjItzBRDfDCnADNVreVYAeWCoCwM2C1HG8Kg21J4qi1dpU8tgmBfBK26RtBMA9bfzPM3Ec7y36lBXH8fb5/v0dQaPRWEjyYXAfZ0ODZF/J4M9h3/pqQZIk20ouQ02IHKAJjaGhobUuNZTk5gO+NQbPyMjIcpK3S2Y5xnxrrEUks9zkSXFjuyHmZJSkCzeI7i4d+dYZegnXN9MtYACnfWsNFpJ7iupkHf1qQ4Mo713MeBtrer5O1PU3aaRp2uM2N/dlxDXtXT85b3W2HO1qlZPFpIv8vsd590jgLKMjC2RNitr43EsjAkzJ2rzGRJVwNXqvI8vXhMgTX12MBjDuGkSiexcBp46XrppwVyOCaHXmj1cNuRulQh+vegfgiZv4dOO1bpZZB8cVRVEURVEURVEURVEURVGMb34BIkUIizEBRwIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackbutton);
export default __webpack_public_path__ + "static/media/backbutton.07df4a19604a467aa80d2e1ce794aa01.svg";
export { ForwardRef as ReactComponent };